import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

function MenuItem({ icon, text, colors, locationPath, isClosed }) {
  const [hover, setHover] = useState(false);
  const [active, setActive] = useState(false);
  const location = useLocation();
  const url = location.pathname;

  useEffect(() => {
    if (locationPath === url) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [url, locationPath]);

  return (
    <div
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      onClick={(e) => {
        setActive(!active);
      }}
      style={{
        cursor: 'pointer',
        background: `${
          hover
            ? colors.menuBgHover
            : active
            ? colors.menuBgActive
            : colors.menuBgActive
        }`,
      }}
      // className={`h-[3.1vh]  ${
      //   isClosed ? 'aspect-square' : 'w-full'
      // }  items-center ${
      //   isClosed ? 'justify-center' : 'justify-between'
      // } flex py-[0.7vh] rounded-md px-3 gap-5 text-sm font-medium `}
      className={`h-[4.1vh] flex py-[0.7vh] rounded-md px-3 text-sm font-medium items-center  ${
        isClosed ? 'aspect-square justify-center' : 'w-full justify-between'
      }`}
    >
      <div className="h-full w-auto flex items-center gap-5">
        <div className="h-full aspect-square mx-auto">
          {hover || active ? icon[1] : icon[0]}
        </div>
        {!isClosed && <p className="tpm-text-bold">{text}</p>}
      </div>
      {active && !isClosed && (
        <motion.div
          initial="start"
          whileInView={'end'}
          variants={{
            start: {
              opacity: 0,
              x: -50,
            },
            end: {
              opacity: 1,
              x: 0,
            },
          }}
          style={{ background: colors.secondryColor }}
          className="w-2 aspect-square rounded-full self-center"
        />
      )}
    </div>
  );
}

const mapState = (state) => ({
  colors: state.theme.colors,
});

const mapDispatch = (dispatch) => ({});

export default connect(mapState, mapDispatch)(MenuItem);
